import Web3 from 'web3'

import AragonTokenSale from '../lib/AragonTokenSale'
import config from '../config'

const ProviderEngine = require('web3-provider-engine')
const CacheSubprovider = require('web3-provider-engine/subproviders/cache.js')
const FixtureSubprovider = require('web3-provider-engine/subproviders/fixture.js')
const FilterSubprovider = require('web3-provider-engine/subproviders/filters.js')
const RpcSubprovider = require('web3-provider-engine/subproviders/rpc.js')

let hadWeb3 = false

const isSafari = () => navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1

const getNetwork = async () => (
  new Promise((resolve) => {
    if (!window.web3) {
      resolve(undefined)
    } else {
      window.web3.version.getNetwork((error, result) => {
        resolve(result)
      })
    }
  })
)

const loadWeb3 = async () => {
  if (isSafari()) {
    window.web3 = new Web3(new Web3.providers.HttpProvider(config.node))
    return
  }

  const network = await getNetwork()
  if (network === config.networkId) {
    hadWeb3 = true
    window.web3 = new Web3(window.web3.currentProvider)
  } else {
    // set the provider you want from Web3.providers
    const engine = new ProviderEngine()
    window.web3 = new Web3(engine)

    // static results
    engine.addProvider(new FixtureSubprovider({
      web3_clientVersion: 'ProviderEngine/v0.0.0/javascript',
      net_listening: true,
      eth_hashrate: '0x00',
      eth_mining: false,
      eth_syncing: true,
    }))

    // cache layer
    engine.addProvider(new CacheSubprovider())

    // filters
    engine.addProvider(new FilterSubprovider())

    // data source
    engine.addProvider(new RpcSubprovider({
      rpcUrl: config.node,
    }))

    // network connectivity error
    engine.on('error', (err) => {
      // report connectivity errors
      console.error(err.stack)
    })

    // start polling for blocks
    engine.start()
  }
}

const updateCollected = async (store, sale) => {
  const w = await sale.totalCollected()
  store.commit('setTotalCollected', { ether: window.web3.fromWei(w).toFixed(2) })
}

const updateCap = async (store, sale, revealed) => {
  const w = await sale.hardCap()
  store.commit('setCap', {
    cap: window.web3.fromWei(w).toFixed(2),
    revealed,
  })
}

const getBlock = blockHash => (
  new Promise((resolve, reject) => {
    window.web3.eth.getBlock(blockHash, (err, block) => {
      if (err) reject(err)
      resolve(block)
    })
  })
)

const start = async (store) => {
  await loadWeb3()
  store.commit('setHadWeb3', hadWeb3)

  AragonTokenSale.setProvider(window.web3.currentProvider)
  const saleContract = AragonTokenSale.at(config.saleAddress)

  saleContract.NewBuyer({}).watch((err, ev) => {
    if (!err && ev) updateCollected(store, saleContract)
  })
  updateCollected(store, saleContract)

  saleContract.CapRevealed({}).watch((err, ev) => {
    if (!err && ev) {
      updateCap(store, saleContract, true)
    }
  })
  updateCap(store, saleContract)

  window.web3.eth.getBlockNumber((er, b) => store.commit('setCurrentBlock', { blockNumber: b }))

  window.web3.eth.filter('latest', async (err, blockHash) => {
    if (err) return
    const block = await getBlock(blockHash)
    store.commit('setCurrentBlock', { blockNumber: block.number })
  })

  const blocks = await Promise.all([saleContract.initialBlock(), saleContract.finalBlock()])
  store.commit('setSaleBlocks', {
    initialBlock: blocks[0].toNumber(),
    finalBlock: blocks[1].toNumber(),
  })
}

export default function watchSale() {
  return (store) => {
    setTimeout(() => start(store), 1000)
    if (isSafari()) {
      setInterval(() => start(store), 15 * 1000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/salePlugin.js